import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService, UserService } from "app/auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { CostService } from "app/modules/cost/cost.service";
import { IStructureCostForm, IStructureCostList } from "app/modules/cost/models/structure-cost";
import moment from "moment";

@Component({
  selector: "app-structure-cost-list",
  templateUrl: "./structure-cost-list.component.html",
  styleUrls: ["./structure-cost-list.component.scss"]
})
export class StructureCostListComponent implements OnInit {
  @ViewChild("table") table: any;
  public contentHeader: IContentHeader = null;
  public searchKey: string = null;
  public tableLimit: number = 10;
  public structureCostList: IStructureCostList[] = [];
  public filterStructureCostList: IStructureCostList[] = [];
  public selectedStructureCost: IStructureCostList = null;
  public formGroup: FormGroup;
  public showErrors: boolean = false;
  public editMode: boolean = false;
  public selectedMonth: string = moment().format("M");
  public selectedYear: string = moment().format("YYYY");
  public availableMonths: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  public availableYears: string[] = [];
  public isSelectedAChild: boolean = false;
  public selectedParent: IStructureCostList = null;
  private childrenElementNumber: number = 1;
  public totalEstimateAmount: number = 0;
  public totalRealAmount: number = 0;
  public showEditField: { user_hash: boolean; from: boolean; to: boolean; description: boolean, amount: number | string } = {
    user_hash: false,
    from: false,
    to: false,
    description: false,
    amount: 0
  };
  public employeesList: any = [];
  public maxDateSelectedMonth: { year: number; month: number; day: number } = null;
  public minDateSelectedMonth: { year: number; month: number; day: number } = null;

  public clicked: boolean = false;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _costService: CostService,
    private router: Router,
    public _modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _userService: UserService
  ) {
    this.contentHeader = {
      headerTitle: "MENU.STRUCUTURE_COST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.STRUCUTURE_COST",
            isLink: false
          }
        ]
      }
    };

    this.formGroup = this.formBuilder.group({
      user_hash: [[], [Validators.required]],
      from: [null, [Validators.required]],
      to: [null],
      description: [null, [Validators.required, Validators.maxLength(255)]]
    });

    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this._utilService.showLoading();
    if (!this._authenticationService.hasCapability("show_menu_structure_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    for (let i = 2023; i <= moment().year()+1; i++) {
      this.availableYears.push(String(i));
    }
    this.employeesList = await this._userService.getList('employee', null, null, 'complete_name,hash');
    await this.loadData().then(() => this._utilService.hideLoading());
  }

  async loadData() {
    //Se il mese selezionato è futuro restituisco errore
    if (
      Number(this.selectedYear) > Number(moment().format("YYYY")) ||
      (Number(this.selectedMonth) > Number(moment().format("M")) && Number(this.selectedYear) >= Number(moment().format("YYYY"))) ||
      (Number(this.selectedMonth) >= Number(moment().format("M")) && Number(this.selectedYear) > Number(moment().format("YYYY")))
    ) {
      await this._utilService.showSWALError({ text: "ERROR_MONTH_GREATHER_THAN_MOMENT_NOW" });
      return false;
    }

    //Con minDateSelectedMonth e maxDateSelectedMonth gestiamo il range di date selezionabili nel datepicker
    let lastDaySelectedMonth = moment()
      .month(Number(this.selectedMonth) - 1)
      .endOf("month")
      .format("DD");
    this.minDateSelectedMonth = {
      year: Number(this.selectedYear),
      month: Number(this.selectedMonth),
      day: 1
    };
    this.maxDateSelectedMonth = {
      year: Number(this.selectedYear),
      month: Number(this.selectedMonth),
      day: Number(lastDaySelectedMonth)
    };

    this.totalRealAmount = 0;
    this.totalEstimateAmount = 0;
    this._utilService.showLoading();
    this.structureCostList = await this._costService.getStructureCostList(Number(this.selectedMonth), Number(this.selectedYear)).then((structureCostList: any) => {
      return structureCostList.map((structure_cost: any) => {
        let employeesName = [];

        structure_cost.amount = 0;
        if (structure_cost && structure_cost.children && structure_cost.children.length > 0) {
          structure_cost.children.map((child: any) => {
            //child.amount = child.amount > 0 ? child.amount / child.commissions_number : 0;
            employeesName.push(child.user.complete_name);
            structure_cost.amount += child.amount;
            this.totalRealAmount += child.amount;
            this.totalEstimateAmount += child.estimate_amount;
          });
          structure_cost.employees_names_formatted = employeesName.join(", ");
        }

        structure_cost.amount = this._utilService.addDotsToNumber(structure_cost.amount);
        return structure_cost;
      });
    });
    this.search();
    this._utilService.hideLoading();
  }

  search(): void {
    let filteredArray: IStructureCostList[] = this.structureCostList;

    if (this.searchKey && this.searchKey.length > 0) {
      const key: string = this.searchKey.toLowerCase();
      filteredArray = filteredArray.filter((structureCost: IStructureCostList) => structureCost.description.toLowerCase().includes(key) || structureCost?.user?.complete_name?.toLowerCase().includes(key));
    }
    this.filterStructureCostList = filteredArray;
  }

  updateTableLimit(event: { target: { value: string } }): void {
    this.tableLimit = Number(event.target.value);
  }

  formatLabel(month: number | string) {
    //Refactor della label filtro mese
    const date = moment();
    date.set("month", Number(month) - 1);
    return date.format("MMMM");
  }

  toggleExpandRow(row, expanded) {
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
    }
    if (row.children && row.children.length > 0) {
      this.childrenElementNumber = row.children.length;
    }

    this.table.rowDetail.toggleExpandRow(row);

    setTimeout(() => {
      const rowWidth: number | null = document.querySelector(".datatable-row-wrapper:first-child").clientWidth;
      const childDatatable: any = document.querySelector(".child-datatable");

      if (childDatatable) {
        childDatatable.style.width = `${rowWidth}px`;

        const anchor: any = document.querySelector(".datatable-row-wrapper:first-child a[title=\"Expand/Collapse Row\"]");
        if (anchor && this._utilService.isDesktop) {
          childDatatable.style.paddingLeft = `calc(3.65rem + ${anchor.clientWidth}px)`;
        }

        const rowDetail: any = document.querySelector(".datatable-row-detail");
        if (rowDetail) {
          rowDetail.style.height = `${document.querySelector(".child-datatable")?.clientHeight || 0}px`;
        }
      }
    });
  }

  openModal(modal, cost, parent) {
    this._modalService.open(modal, {
      centered: true,
      size: "md",
      backdrop: false,
      keyboard: false
    });
    this.selectedStructureCost = cost;
    if (!!parent) {
      this.isSelectedAChild = true;
      this.selectedParent = parent;
      //Diamo la stessa description del padre
      this.formGroup.patchValue({
        description: this.selectedParent.description
      });
    }
    if (!!this.selectedStructureCost) {
      this.editMode = true;
      this.formGroup.patchValue({
        user_hash: cost.user.user_hash ? [cost.user.user_hash] : null,
        amount: this._utilService.addDotsToNumber(cost.amount),
        description: cost.description,
        from: this._utilService.formatDate(cost.from, "YYYY-MM-DD"),
        to: this._utilService.formatDate(cost.to, "YYYY-MM-DD")
      });
    } else {
      //Nel crea mostriamo tutti i field
      this.showEditField = {
        user_hash: true,
        from: true,
        to: true,
        description: true,
        amount: 0
      };
    }
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.patchValue({
      user_hash: null,
      from: null,
      to: null,
      description: null
    });
    this.showEditField = {
      user_hash: false,
      from: false,
      to: false,
      description: false,
      amount: 0
    };
    this.showErrors = false;
    this.formGroup.markAsUntouched();
    this.selectedParent = null;
    this.editMode = false;
    this.isSelectedAChild = false;
    this.selectedStructureCost = null;
  }

  formHasError(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  takeDate(event: any, field: string) {
    if (field === "from") {
      this.formGroup.patchValue({
        from: event
      });
    }
    if (field === "to") {
      this.formGroup.patchValue({
        to: event
      });
    }
  }

  formatMoneyValue() {
    this.formGroup.patchValue({ amount: this._utilService.addDotsToNumber(this.formGroup.value.amount) });
  }

  toggleField(field: string) {
    //In caso il costo abbia dei figli l'importo non è editabile perché composto dalle sottocategorie
    if (field === "amount") {
      this._utilService.showSWALError({ text: "AMOUNT_NOT_EDITABLE" });
      return false;
    }
    //In caso sia una sottocosto la descrizione non è modificiabile
    if (field === "description" && this.isSelectedAChild) {
      this._utilService.showSWALError({ text: "DESCRIPTION_NOT_EDITABLE" });
      return false;
    }
    this.showEditField[field] = !this.showEditField[field];
  }

  async reloadEmployeeCost(structure_id: number){
    try {
      this._utilService.showLoading();
      await this._costService.updateStructureEmployeeCost({ id: structure_id });
      await this.loadData();
      this._utilService.hideLoading();
      await this._utilService.showToastrSuccess('SUCCESS_STRUCTURE_COST_UPDATE');
    } catch (err: any) {
      this._utilService.hideLoading();
      await this._utilService.showToastrError('ERROR_STRUCTURE_COST_UPDATE')
    }
  }

  async addNewCost($event: any) {
    $event.preventDefault()
    $event.stopPropagation()
    $event.stopImmediatePropagation()
    if(this.clicked) return false;
    if (!this._authenticationService.hasCapability("create_structure_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.formGroup.invalid) {
      await this._utilService.showSWALError({ text: "COMPILE_ALL_FIELD" });
      if (!this.formGroup.value.from) {
        await this._utilService.showSWALError({ text: "INSERT_START_DATE" });
      }
      return false;
    }
    this.clicked = true
    //Check date
    if (moment(this.formGroup.value.from) > moment(this.formGroup.value.to)) {
      this.showErrors = true;
      await this._utilService.showSWALError({ text: "ERROR_DATE" });
      return false;
    }
    //All'aggiungi invieremo un array di hash cosi da poter aggiungere più dipendenti

    let data: IStructureCostForm = {
      ...this.formGroup.value,
      parent_id: this.isSelectedAChild ? this.selectedParent.id : null
    };
    if (!data.to || data.to === "") {
      data.to = null;
    }
    this._utilService.showLoading();
    await this._costService
      .createStructureCost(data)
      .then(async () => {
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_STRUCTURE_COST" });
        this.clicked = false
        this.modalClose();
      })
      .catch((err: any) => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_STRUCTURE_COST" });
        this.clicked = false
        console.error(err);
      });
  }

  async editCost($event: any) {
    $event.preventDefault()
    $event.stopPropagation()
    $event.stopImmediatePropagation()
    let isParent: boolean = false;
    if (this.selectedStructureCost && this.selectedStructureCost.children && this.selectedStructureCost.children.length > 0) {
      isParent = true;
    }
    if (!this._authenticationService.hasCapability("edit_structure_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!isParent) {
      if (this.formGroup.invalid) {
        await this._utilService.showSWALError({ text: "COMPILE_ALL_FIELD" });
        if (!this.formGroup.value.from) {
          await this._utilService.showSWALError({ text: "INSERT_START_DATE" });
        }
        return false;
      }
      //Check date
      if (moment(this.formGroup.value.from) > moment(this.formGroup.value.to)) {
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
    } else {
      //Se è un padre controlliamo solo la traduzione
      if (!this.formGroup.value.description) {
        await this._utilService.showSWALError({ text: "INSERT_DESCRIPTION" });
        return false;
      }
    }

    let data: IStructureCostForm = {
      ...this.formGroup.value,
      parent_id: this.isSelectedAChild ? this.selectedParent.id : null
    };
    if (!data.to || data.to === "") {
      data.to = null;
    }
    //Al modifica della sottocategoria inivio solo un hash e non un array di hash
    if (this.editMode && this.isSelectedAChild && this.formGroup.value.user_hash && this.formGroup.value.user_hash.length === 1) {
      data.user_hash = this.formGroup.value.user_hash[0];
    }
    this._utilService.showLoading();
    await this._costService
      .editStructureCost(this.selectedStructureCost.id, data)
      .then(async () => {
        await this.loadData();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_STRUCTURE_COST" });
        this.modalClose();
      })
      .catch((err: any) => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDIT_STRUCTURE_COST" });
        console.error(err);
      });
  }

  async delete(structure_cost: IStructureCostList) {
    if (!this._authenticationService.hasCapability("delete_structure_cost")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${structure_cost.user.complete_name ? structure_cost.user.complete_name : structure_cost.description}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._costService
            .deleteCostStructure(structure_cost.id)
            .then(async () => {
              this._utilService.hideLoading();
              await this.loadData();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_STRUCTURE_COST" });
            })
            .catch(async () => {
              this._utilService.hideLoading();
              await this._utilService.showSWALError({ text: "ERROR_DELETE_STRUCTURE_COST" });
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT"
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_STRUCTURE_COST" });
      });
  }
}
